import { Grid, NetworkIcon, Typography } from 'gu-ui-kit'
import PageHeader from 'components/PageHeader'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const AccountHeader = ({ networkType, accountName, accountLogin }) => {
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()

  if (!networkType) return null

  return (
    <Grid
      alignItems={'start'}
      wrap={false}
      justifyContent={'start'}
      gap={!breakpoints.fb ? 16 : 24}
      className={'layout-tile margin-bottom-16'}
    >
      <NetworkIcon
        width={!breakpoints.fb ? 34 : 44}
        height={!breakpoints.fb ? 34 : 44}
        name={networkType}
        rounded
      />
      <Grid
        direction={'column'}
        gap={8}
      >
        <PageHeader>{t(`services::networks.${networkType}`)}</PageHeader>
        {(accountName || accountLogin) && (
          <Grid
            direction={'column'}
            gap={8}
          >
            {(accountName || accountLogin) && (
              <Typography
                variant={'Body-15'}
                color={'Label-Fifth'}
                component={'div'}
                noMargin
              >
                {`${t('services::account_label')} : ${accountName || accountLogin}`}
              </Typography>
            )}
            {accountLogin && (
              <Typography
                variant={'Body-15'}
                color={'Label-Secondary'}
                component={'div'}
                noMargin
              >
                {`${t('services::login')} : ${accountLogin}`}
              </Typography>
            )}
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

AccountHeader.propTypes = {
  networkType: PropTypes.string,
  accountName: PropTypes.string,
  accountLogin: PropTypes.string,
}

export default AccountHeader
